import { Modal, Text, TextContainer } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

export const RequiredDocumentRemovalModal = ({ isOpen, closeModal }: { isOpen: boolean; closeModal: () => void }) => {
  const intl = useIntl();

  return (
    <Modal
      title={intl.formatMessage({
        id: "funding-application: required document removal modal - title",
        defaultMessage: "Sorry, removing this is not possible",
      })}
      primaryAction={{
        onAction: closeModal,
        content: intl.formatMessage({
          id: "funding-application: required document removal modal - okay",
          defaultMessage: "Okay",
        }),
      }}
      isOpen={isOpen}
      onClose={closeModal}
    >
      <TextContainer>
        <Text>
          {intl.formatMessage({
            id: "funding-application: required document removal modal - can not remove",
            defaultMessage:
              "You must provide this document before submitting your application. Together with your banking data, this gives us important information about the overall financial health of your business to inform our funding decision.",
          })}
        </Text>
        <Text>
          {intl.formatMessage({
            id: "funding-application: required document removal modal - chat to us message",
            defaultMessage:
              "If you need help, chat to us using the link on this page or reach out to your Wayflyer representative directly if you have one.",
          })}
        </Text>
      </TextContainer>
    </Modal>
  );
};
